// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_ralP-","modal-wrap":"modal-wrap_CIn0u","close-icon":"close-icon_nXjtb","content-wrap":"content-wrap_eoWMB"};